module.exports = __webpack_public_path__ + "static/media/postgre.968eb748.png";